import React, { useState, useEffect, useContext, useRef } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import userService from '../../services/user.service';
import { AuthContext } from '../../contexts/AuthContext';
import { sessionService } from '../../sessionService/storage';
import filesService from '../../services/file.service';
import { sourceUrl } from '../../environment';
import { toastOptions } from '../shared/selectStyle';
import ModalYesNo from '../shared/modalYesNo';
import './style.css';
import validateEmail from '../shared/validateEmail';
const modalText = "Are you sure you want to delete your account? All your data, including members and images will be removed permanently.";
const modalHeading = "Permanently deleting account";


const Profile = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { user, setUser } = useContext(AuthContext);
    const [error, setError] = useState(false);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [invalidPassword, setInvalidPasword] = useState(false);
    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
        password: '',
        email: '',
        companyName: ''
    });
    const [avatar, setAvatar] = useState({});
    const [imageBeforeUpload, setImageBeforeUpload] = useState(null);
    const [file, setFile] = useState();
    const refFileInput = useRef(null);
    const [showModalDelete, setShowModalDelete] = useState(false);

    useEffect(() => {
        getUserById(user._id)
    }, []);

    const getUserById = async (userId) => {
        const response = await userService.getUserById(userId);
        setUserData({ ...response, avatarToDelete: response.avatar })

    }

    const handleChange = (event) => {
        setError(false);
        setInvalidEmail(false);
        setInvalidPasword(false);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setUserData({
            ...userData,
            [name]: value.trim()
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            const response = await userService.updateUser(userData);
            const { email, firstName, lastName, companyName } = response.user || response;

            sessionService.updateUser({ ...user, email, firstName, lastName, companyName });
            setUserData(response);
            setUser({ ...user, email, firstName, lastName, companyName });
            toast.success("Profile is successfully updated!", toastOptions);

        }
    }

    const handleChangeFile = (e) => {
        let file = e.target.files[0];
        setFile(file);
        if (file) {
            setImageBeforeUpload(URL.createObjectURL(e.target.files[0]));
        } else {
            setImageBeforeUpload('');
        }
    }

    const triggerUploadBtn = () => {
        refFileInput.current.click()
    }

    const changeAvatar = async () => {
        if (file) {
            await getUploadLink(file);
        } else {
            toast.error("Try upload image again!", toastOptions);
        }
    }
    const getUploadLink = async (file) => {
        let fileData = file.name;
        let dotIndex = fileData.lastIndexOf(".");
        let fileExt = fileData.slice(dotIndex + 1);
        let data = {
            ext: fileExt,
        }
        setAvatar({ ...avatar, ...data })
        if (fileExt) {
            const response = await userService.getUploadLinkAndUpdateAvatar(data);
            if (response) {
                await filesService.uploadImageAmazon(response.url, file);
                sessionService.updateUser({ ...user, avatarId: user._id, avatarExt: fileExt + '?t=' + new Date().getTime() });
                setUser({ ...user, avatarId: user._id, avatarExt: fileExt + '?t=' + new Date().getTime() });
                toast.success("Avatar uploaded successfully !", toastOptions);

            } else {
                toast.error("Upload url error!", toastOptions);
            }
        } else {
            toast.error("Invalid data!", toastOptions);
        }
    }

    const validateForm = () => {
        if (userData.email) {
            if (!validateEmail(userData.email)) {
                setInvalidEmail(true)
                return false
            }
        }
        if (userData.isCompany) {
            let isValid = userData.companyName && userData.password && userData.email;
            if (!isValid) {
                setError(true);
                return isValid;
            };
            if (userData.password.length < 4) {
                setInvalidPasword(true);
                return false;
            }
            return isValid;
        } else {
            let isValid = userData.password && userData.email && userData.firstName && userData.lastName;
            if (!isValid) {
                setError(true);
                return isValid;
            };
            if (userData.password.length < 4) {
                setInvalidPasword(true);
                return false;
            }
            return isValid;
        }
    }
    const deleteCompany = async () => {
        await userService.deleteCompany();
        toast.success("You are permanently deleted your account", toastOptions);
        sessionService.destroy()
        history.push('/msg');
        setUser(null);
    }
    const closeModal = async () => {
        setShowModalDelete(false);
    }

    const openYesNoModal = () => {
        setShowModalDelete(true);
    }
    const handleYesNoAnswer = (answer) => {
        if (answer === 'yes') {
            deleteCompany(0);
            closeModal();
        } else {
            closeModal();
        }
    }
    return (
        <div className="dashboard-view space-around profile-page">
            <h4 className="h4-title">{t('profile.title')}</h4>
            <div className="upload-avatar-wrapper">
                <div>
                    <div onClick={triggerUploadBtn} className="avatar-placeholder">
                        {!imageBeforeUpload ? <img src={user.avatarId ? `${sourceUrl}${user.avatarId}.${user.avatarExt}` : `/assets/images/avatar.png`} alt="description" />
                            : <img src={imageBeforeUpload} alt="Upload box" />}
                    </div>
                    <input ref={refFileInput} className='upload-input' type="file" onChange={handleChangeFile} />
                    <p className="mb-0 pl-2" onClick={triggerUploadBtn} > {t('profile.upload')} </p>
                </div>
                <button className="btn btn-blue" onClick={changeAvatar}>{t('update')}</button>
            </div>

            <form className="form-sm" onSubmit={handleSubmit}>
                {userData.isCompany ? <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.companyName')}:</label>
                    <input id='companyName' className="form-control" type="text" name="companyName" value={userData.companyName} onChange={handleChange} placeholder={t('placeholder.companyName')} />
                </div> : null}
                {!userData.isCompany ? <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.firstname')}:</label>
                    <input id='firstname' className="form-control" type="text" name="firstName" value={userData.firstName} onChange={handleChange} placeholder={t('placeholder.firstname')} />
                </div> : null}
                {!userData.isCompany ? <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.lastname')}:</label>
                    <input id='lastName' className="form-control" type="text" name="lastName" value={userData.lastName} onChange={handleChange} placeholder={t('placeholder.lastname')} />
                </div> : null}
                <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.email')}:</label>
                    <input type="email" className="form-control" name="email" value={userData.email} onChange={handleChange} placeholder={t('placeholder.email')} />
                </div>
                <div className="form-group custom-input">
                    <label htmlFor="">{t('placeholder.password')}:</label>
                    <input type="text" className="form-control" name="password" value={userData.password} onChange={handleChange} placeholder={t('placeholder.password')} />
                </div>
                {error ? <div className="message-alert"><p>{t('requiredFields.msg')}</p></div> : null}
                {invalidEmail ? <div className="message-alert"><p>Please enter valid email address!</p></div> : null}
                {invalidPassword ? <div className="message-alert"><p>Password needs to be longer than 3 characters!</p></div> : null}
          
                <button className="btn btn-blue">{t('update')}</button>
            </form>
            {showModalDelete ? <ModalYesNo heading={modalHeading} text={modalText} show={showModalDelete} closeModal={closeModal} handleYesNoAnswer={handleYesNoAnswer} /> : null}
            {userData.isCompany ? <div className="permanetly-delete">
                <h5>{t('profile.permanetlyDelete')}</h5>
                <button className="btn btn-white" onClick={openYesNoModal}>{t('delete')}</button>
            </div> : null}
        </div>
    );
}

export default Profile;



// WEBPACK FOOTER //
// ./src/components/profileComponent/profile.js